import actionTypes from '../constants/action-types';

const setSupportedBlockCategoriesForRegeneration = (categories) => ({
  type: actionTypes.SET_SUPPORTED_BLOCK_CATEGORIES_FOR_REGENERATION,
  payload: {
    categories,
  },
});

export default setSupportedBlockCategoriesForRegeneration;
